import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: localStorage.getItem('lang') || 'nl'
  },
  mutations: {
    setSiteLang: (state, payload) => {
      state.language = payload
    }
  },
  actions: {
    setLanguage: ({commit}, payload) => {
      commit('setSiteLang', payload)
    }
  },
  getters: {
    getLanguage: (state) => {
      return state.language
    }
  }
})
